<template lang="pug">
.organizer-contacts
  a.organizer-contacts__item(
    v-if="organization.contact_email"
    :href="`mailto:${organization.contact_email}`"
  )
    v-icon.organizer-contacts__icon(size="24" color="redesignPrimary") $imail
    span.organizer-contacts__label {{ organization.contact_email }}
  a.organizer-contacts__item(
    v-if="organization.contact_phone"
    :href="`tel:+7${organization.contact_phone}`"
  )
    v-icon.organizer-contacts__icon(size="24" color="redesignPrimary") $iphone-call
    span.organizer-contacts__label {{ organization.contact_phone }}
</template>

<script>
export default {
  name: 'OrganizerContacts',
  props: {
    organization: { type: Object, default: () => ({}) },
  },
};
</script>

<style lang="scss" scoped>
.organizer-contacts {
  display: flex;
  align-items: center;
  gap: 32px;

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__icon {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: -4px;
      left: -4px;
      z-index: -1;
      width: 32px;
      height: 32px;
      background-color: #{$redesignPrimaryLighten};
      border-radius: 50%;
    }
  }

  &__label {
    color: #{$redesignPrimaryDarken};
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: lowercase;
  }
}
</style>
